import Vue from "vue";
import VueApollo from "vue-apollo";

import { ApolloClient } from "apollo-client";
import { onError } from 'apollo-link-error';
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";

import { GRAPH_ENDPOINT } from "@/api/environment";
import { getAuthToken } from "../utils/cookie";
import router from "../router";

// Install the vue plugin
Vue.use(VueApollo);

const link = (() => {
	const httpLink = createUploadLink({ uri: GRAPH_ENDPOINT });

	const authLink = setContext(async (_, { headers }) => {
		const token = getAuthToken();
		return {
			headers: {
				...headers,
				Authorization: token ? `Bearer ${token}` : "",
			},
		};
	});

	const resetToken = onError(({ networkError }) => {
		if (networkError && [401, 403].includes(networkError.statusCode)) {
			router.push({ name: "Logout" });
		}
	});

	return authLink.concat(resetToken).concat(httpLink);
})();

export const apolloClient = new ApolloClient({
	link,
	cache: new InMemoryCache(),
});

// Call this in the Vue app file
export function createProvider(options = {}) {
	// Create vue apollo provider
	const apolloProvider = new VueApollo({
		defaultClient: apolloClient,
		defaultOptions: {
			$query: {
				// fetchPolicy: 'cache-and-network',
			},
		},
		errorHandler(error) {
			// eslint-disable-next-line no-console
			console.log(
				"%cError",
				"background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;",
				error.message
			);
		},
	});

	return apolloProvider;
}
